export default __webpack_public_path__ + "static/media/elearn.5a3f68c5.jpeg";